<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 48 48">
    <path
      fill="#CFD8DC"
      d="M12,40V20h32v20c0,2.2-1.8,4-4,4H16C13.8,44,12,42.2,12,40z"
    />
    <path
      fill="#78909C"
      d="M44,16v6H12v-6c0-2.2,1.8-4,4-4h24C42.2,12,44,13.8,44,16z"
    />
    <path
      fill="#37474F"
      d="M37 13A3 3 0 1 0 37 19 3 3 0 1 0 37 13zM20 13A3 3 0 1 0 20 19 3 3 0 1 0 20 13z"
    />
    <path
      fill="#B0BEC5"
      d="M37 10c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2s2-.9 2-2v-4C39 10.9 38.1 10 37 10zM20 10c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2s2-.9 2-2v-4C22 10.9 21.1 10 20 10z"
    />
    <path
      fill="#90A4AE"
      d="M32 34H36V38H32zM26 34H30V38H26zM20 34H24V38H20zM32 28H36V32H32zM26 28H30V32H26zM20 28H24V32H20z"
    />
    <path fill="#F44336" d="M16 3A12 12 0 1 0 16 27A12 12 0 1 0 16 3Z" />
    <path fill="#EEE" d="M16 6A9 9 0 1 0 16 24A9 9 0 1 0 16 6Z" />
    <g>
      <path d="M15 8H17V15H15z" />
      <path
        d="M16.9 14.2H18.799999999999997V19.6H16.9z"
        transform="rotate(134.999 17.9 16.9)"
      />
      <path d="M16 13.5A1.5 1.5 0 1 0 16 16.5A1.5 1.5 0 1 0 16 13.5Z" />
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "ScheduleIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
